import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Chart } from 'chart.js';
import { GlobalConstantsChart, GlobalConstantsDom, GlobalFunctions } from 'globales-projekt-angular';
import { Guid } from 'guid-typescript';
import { Subscription } from 'rxjs';
import { ErgebnisGebaeude } from 'src/app/data/ws/ergebnis/gebaeude/ergebnis-gebaeude.model';
import { Functions } from 'src/app/functions/functions.module';
import { ConstantsDom } from 'src/app/immutable/constants-dom';
import { ConstantsTexte } from 'src/app/immutable/constants-texte';
import { LocalService } from 'src/app/services/local.service';

@Component({
  selector: 'app-chart-inv-bed-kb-je-m-quadrat-fkt',
  templateUrl: './chart-inv-bed-kb-je-m-quadrat-fkt.component.html',
  styleUrls: ['./chart-inv-bed-kb-je-m-quadrat-fkt.component.css'],
})
export class ChartInvBedKbJeMQuadratFktComponent implements OnInit {
  @ViewChild('chart', { static: false }) chart!: ElementRef;

  private guid: string = Guid.create().toString();
  private ergebnisseSubscription!: Subscription;
  private chartInstance!: Chart;
  private isUpdated = false;

  constructor(public localService: LocalService) { }

  ngOnInit(): void {
    this.ergebnisseSubscription = this.localService.diagramErgebnisse.subscribe((ergebnisse) => {
      if (ergebnisse) {
        this.createChart(ergebnisse.ergebnisGebaeudeList!);
      }
    });
  }

  ngOnDestroy(): void {
    if (this.ergebnisseSubscription) {
      this.ergebnisseSubscription.unsubscribe();
    }
  }

  ngAfterViewChecked(): void {
    if (!this.isUpdated) {
      const element = document.getElementById(ConstantsDom.DOM_CHART_INV_BED_KB_JE_Q2_FKT);
      if (element) {
        element.setAttribute(GlobalConstantsDom.DOM_ID, this.guid);
        this.isUpdated = true;
      }
    }
  }

  async createChart(ergebnisGebaeudeList: ErgebnisGebaeude[]) {
    await new Promise((f) => setTimeout(f, 1));

    if (this.localService.istGebaeude.value) return;

    let chartDataSets: any[] = [];
    let temp = ergebnisGebaeudeList;
    if (ergebnisGebaeudeList.length != 0) {
      temp =
        ergebnisGebaeudeList.length > 1
          ? ergebnisGebaeudeList.slice(1)
          : ergebnisGebaeudeList.slice(0, 1);

        temp[0].ergebnisInvBedFktKomplett.ergebnisInvBedFktList.forEach(
        (entry, i) => {
          let data: number[] = [];

          temp.forEach((entry2) => {
            data.push(
              entry2.ergebnisInvBedFktKomplett.ergebnisInvBedFktList[i].invBedarf
            );
          });

          chartDataSets.push({
            label: entry.kostenblock,
            backgroundColor: entry.diagrammfarbe,
            data: data,
          });
        }
      );
    }

    let titleText: string = ConstantsTexte.INVESTITIONSBEDARF_JE_M2_BRUTTO_FKTFLAECH;
    let seitenUeberschriftText: string = ConstantsTexte.INVESTITIONSBEDARF_IN_EURO_M2;

    if (this.chartInstance) {
      this.chartInstance.destroy();
    }

    this.chartInstance = GlobalFunctions.getDiagramm(this.guid, Functions.getChartLabels(temp, this.localService.istGebaeude.value), chartDataSets, titleText, seitenUeberschriftText, 0, false, GlobalConstantsChart.FARBE_SCHWARZ);

  }
}
